module.exports = ".content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/advertising/advertising.component.scss
// module id = ./src/app/master/advertising/advertising.component.scss
// module chunks = main